<!--图片上传-->
<template>
  <div>
    <el-upload style="display:flex;align-items: center;
"
               :action="api.uploadFileUrl"
               :on-remove="handleRemove"
               accept=".jpeg,.png,.jpg,.bmp,.gif"
               :before-upload="checkFileType"
               list-type="picture-card"
               :file-list="photoList"
               :on-success="(res,file, fileList) => {handleSuccess(res,file, fileList)}"
               :on-change="(files, fileList) => {handleImageChange(fileList)}"
               :auto-upload="true"
               :headers="headers"
               :disabled="isJustShow"
               :on-preview="handlePictureCardPreview"
    >
      <i slot="default" class="el-icon-plus"></i>
    </el-upload>


    <el-image-viewer
      style="z-index: 9999;"
      v-if="dialogVisible"
      :on-close="closeImgViewer"
      :url-list="dialogImageUrlList"/>
  </div>
</template>

<script>
import api from "@/api/projectApi";
import store from "@/store";
import * as imageConversion from 'image-conversion'


export default {
  name: 'photoUpload',
  props: {
    photoUrl: {
      type: [String],
      require: true
    },
    photoShow:{
      type: Boolean,
    }
  },

  created() {
    // let tmpUrl = this.photoUrl;
    console.log('photoUrl received:', this.photoUrl);
    let list = []
    if (this.photoUrl !== null && this.photoUrl !== '' && this.photoUrl !== undefined) {
      list.push({url: this.photoUrl})
    }
    this.photoList = list
    if (this.photoShow){
      this.isJustShow = this.photoShow
    }
  },

  computed: {
    api() {
      return api
    },
    headers: function () {
      const tenantId = store.getters.userInfo.tenantId
      return {
        'Authorization': "Bearer " + store.getters.access_token,
        'TENANT-ID': tenantId
      };
    }
  },

  components: {
    'el-image-viewer': () => import('element-ui/packages/image/src/image-viewer')
  },

  data() {
    return {
      photoList: [],
      dialogImageUrlList: [],
      dialogVisible: false,
      isJustShow:false,
    }
  },

  watch: {
    photoUrl: {
      handler(url){
        if (url) {
          let list = []
          if (url !== null && url !== '' && url !== undefined) {
            list.push({url: url})
          }
          this.photoList = list
          console.log(this.photoList,"图片回显");
        } else {
          this.photoList = []
          console.log(this.photoList,"图片???");
        }
      },
      deep: true,
      immediate: false,
    },
    photoList: {
      handler(n) {
        if (n.length > 0) {
          this.$emit('update:photoUrl', this.photoList[0].url)
        } else {
          this.$emit('update:photoUrl', null)
        }
      },
      deep: true,
      immediate: false,
    },

  },


  methods: {
    checkFileType (file) {
      const fileName = file.name
      const fileType = fileName.substring(fileName.lastIndexOf('.'))
      // jpeg,.png,.jpg,.bmp,.gif
      if (
        fileType === '.jpg' ||
        fileType === '.png' ||
        fileType === '.jpeg' ||
        fileType === '.bmp' ||
        fileType === '.gif'
      ) {
        // 不处理
        const isLt1M = (file.size / 1024 / 1024) < 5;
        // if (!isJPG) {
        //   this.$message.error("上传头像图片只能是 JPG 和 PNG 格式!");
        // }
        if (!isLt1M) {
          this.$message.warning("上传图片大小不能超过 5MB! 将进行压缩");
          let myImg = new Promise((resolve) => {
            // 压缩到500KB,这里的500就是要压缩的大小,可自定义
            imageConversion.compressAccurately(file, 500).then((res) => {
              resolve(res);
            });
          });
          console.log(myImg,"压缩后图片");
          return myImg;
        }
        return isLt1M;
      } else {
        this.$message.error(
          '不是,jpeg,.png,.jpg,.bmp,.gif文件,请上传正确的图片类型'
        )
        return false
      }
    },

    handleRemove() {

      this.photoList = []
      this.$emit('removePic', null)
      console.log("删除了照片",this.photoList);

    },

    handleSuccess(res, file, fileList) {
      let url = res.data.url
      console.log(url, "photoUrl")
      let list = []
      if (url !== null && url !== '' && url !== undefined) {
        list.push({url: url})
      }
      this.photoList = list
      console.log(this.photoList,"this.photoList的值");
    },

    handleImageChange(fileList) {
      if (fileList.length > 1) {
        fileList.splice(0, 1);
      }
    },


    handlePictureCardPreview(file) {
      this.dialogImageUrlList = [file.url]
      this.dialogVisible = true
    },


    closeImgViewer() {
      this.dialogVisible = false
    },
  },
};
</script>

<style scoped lang="scss">
// 图片大小
::v-deep .el-upload-list .el-upload-list__item {
  display: inline-block;
  width: 60px!important;;
  height: 60px!important;;
  margin-right: 14px;
  border-radius: 2px;
  padding: 0 !important;
  border-color: #e8e8e8;
  margin-top: 0;
  margin-bottom: 10px;
}
// 边框大小
::v-deep .el-upload-list .el-upload-list__item .el-upload-list__item-thumbnail {
  width: 60px;
  height: 60px;
  padding: 0 !important;
  position: inherit;
  cursor: pointer;
}
// 上传按钮
::v-deep  .el-upload--picture-card {
  margin-top: 0px;
  width: 40px;
  height: 40px;
  line-height: 50px !important;
}
</style>
